import { COUNT_DAYS_SAVE_COOKIE, DEFAULT_COUNTRY_PHONE_CODE } from '../constants';
import { KEY_SHA_MAIL, KEY_SHA_TEL } from '../constants/keys';
import { pushSendUpdEvent } from './analytics';
import { addDaysDate } from './functions';
import { setCookie, removeCookie } from './cookies';

const cookieExpiresAt = addDaysDate(COUNT_DAYS_SAVE_COOKIE);

// SHA-256 hex contains only [0-9a-f]; skip encodeURIComponent to keep cookie readable
const encodeTrackingCookieValue = (value: string): string => value;

export const normalizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

export const formatPhoneToE164 = (phoneNumber: string): string => {
  const withoutSpaces = phoneNumber.replace(/\s/g, '');
  const countryCodeDigits = DEFAULT_COUNTRY_PHONE_CODE.replace(/\D/g, '');

  let localDigits = withoutSpaces.startsWith(DEFAULT_COUNTRY_PHONE_CODE)
    ? withoutSpaces.slice(DEFAULT_COUNTRY_PHONE_CODE.length)
    : withoutSpaces;

  localDigits = localDigits.replace(/\D/g, '');

  if (localDigits.startsWith(countryCodeDigits) && localDigits.length > countryCodeDigits.length) {
    return `+${localDigits}`;
  }

  return `${DEFAULT_COUNTRY_PHONE_CODE}${localDigits}`;
};

export const hashSha256 = async (value: string): Promise<string> => {
  const data = new TextEncoder().encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(hashBuffer))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
};

export const setShaMailCookie = async (email: string): Promise<void> => {
  const normalizedEmail = normalizeEmail(email);
  const hashedEmail = await hashSha256(normalizedEmail);

  setCookie(KEY_SHA_MAIL, hashedEmail, cookieExpiresAt, {
    encode: encodeTrackingCookieValue,
  });

  pushSendUpdEvent();
};

export const setShaTelCookie = async (phoneNumber: string): Promise<void> => {
  const e164Phone = formatPhoneToE164(phoneNumber);
  const hashedPhone = await hashSha256(e164Phone);

  setCookie(KEY_SHA_TEL, hashedPhone, cookieExpiresAt, {
    encode: encodeTrackingCookieValue,
  });

  pushSendUpdEvent();
};

export const clearUserTrackingCookies = (): void => {
  removeCookie(KEY_SHA_MAIL);
  removeCookie(KEY_SHA_TEL);
};
